<template>
  <div class="replyRow" @click="scrollToReply">
    <div class="replyColor" :style="{ backgroundColor: userColor(message.From) }" />
    <div class="replyColumn">
      <div class="replyName" :style="{ color: userColor(message.From) }">
        {{ getUserNameDisplay(message.From) }}
      </div>
      <div class="replyMessageText">
        {{ messageBody }}
      </div>
    </div>
    <!-- Image Message -->
    <div class="replyImageColumn" v-if="message.MessageType === 1">
      <div class="typeIconContainer">
        <img class="typeIcon" src="/images/content-types/content_photo.png">
      </div>
      <img class="replyMessageImage" :src="imageData" v-if="message.MessageType === 1">
    </div>
    <!-- Video Message -->
    <div class="replyImageColumn" v-else-if="message.MessageType === 2">
      <div class="typeIconContainer">
        <img class="typeIcon" src="/images/content-types/content_video.png">
      </div>
      <video class="replyMessageImage">
        <source :src="message.MediaURLs[0]" type="video/mp4">
      </video>
    </div>
    <!-- Location Message -->
    <div class="replyImageColumn" v-else-if="message.MessageType === 4">
      <div class="typeIconContainer">
        <img class="typeIcon" src="/images/content-types/content_location.png">
      </div>
    </div>
    <!-- Audio Message -->
    <div class="replyImageColumn" v-else-if="message.MessageType === 8">
      <div class="typeIconContainer">
        <img class="typeIcon" src="/images/content-types/content_audio.png">
      </div>
    </div>
    <!-- Document Message -->
    <div class="replyImageColumn" v-if="message.MessageType === 100">
      <div class="typeIconContainer">
        <img :src="getMimeImage(message.MediaURLs[0])" @click="openDocument(message.MediaURLs[0])" class="typeIcon">
      </div>
      <img class="replyMessageImage" :src="message.MediaURLs[0]" v-if="message.MessageType === 1">
    </div>
  </div>
</template>

<script>
import {
  messageMixin
} from '@/mixins/messageMixin.js'
import EventBus from '@/eventbus.js'
var vm
export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data () {
    return {
      serviceUrl: '',
      imageData: ''
    }
  },
  mixins: [messageMixin],
  computed: {
    messageBody () {
      if (this.message.MessageType === 4) {
        return 'Konum'
      } else if (this.message.MessageType === 6) {
        return 'Kişi'
      } else if (this.message.MessageType === 8) {
        return 'Ses Kaydı'
      } else {
        return this.message.Body
      }
    }
  },

  methods: {
    image (url) {
      return new Promise(function (resolve, reject) {
        if (vm.message.mv <= 1) {
          resolve(vm.makeBlob(url, url))
        } else {
          let key = '6a61e395-b49a-4468-bee0-27644e95308f'
          var iv = key.split('').reverse().join('')
          let encryptedBody = vm.ewk(url, key, iv)
          resolve(vm.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + url + '&s=' + encodeURIComponent(encryptedBody), url))
        }
      })
    },
    getMimeImage (documentURL) {
      let documentExtension = documentURL.split('.').pop()
      return '/images/mimes/' + documentExtension + '.png'
    },

    openDocument (documentURL) {
      window.open(documentURL)
    },

    scrollToReply () {
      let repliedMessageID = this.message.MessageID

      // If message is within loaded messages
      let activeConversationMessageIDs = this.$store.getters.pagedMessagesOfActiveConv.map(m => m.MessageID)
      if (activeConversationMessageIDs.includes(repliedMessageID)) {
        EventBus.$emit('scrollToReply', repliedMessageID)
      }
    }
  },
  mounted () {
    vm = this
    this.serviceUrl = process.env.VUE_APP_UPLOADURL2
    if (this.message.MessageType === 1) {
      this.image(this.message.MediaURLs[0]).then(function (response) {
        vm.imageData = response
      })
    }
  }
}

</script>

<style lang="less" scoped>
  // We can define Line Height and how many lines to show at minimum and maximum (name line counts as one)
  @lineHeight: 25px;
  @minHeight: (@lineHeight) * 2;
  @maxHeight: (@lineHeight) * 3;

  .replyRow {
    display: flex;
    flex-direction: row;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 14px;
    color: rgb(140, 140, 140);
    background-color: rgba(0, 0, 0, .05);
    margin-right: -15px;
    line-height: @lineHeight;
    min-height: @minHeight;
    max-height: @maxHeight;
    border-radius: 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    overflow: hidden;
    word-break: break-word;
    cursor: pointer;
  }

  .replyRow:hover {
    -moz-box-shadow: inset 1px 1px 10px 0px rgba(0, 0, 0, .5);
    -webkit-box-shadow: inset 1px 1px 10px 0px rgba(0, 0, 0, .5);
    box-shadow: inset 1px 1px 10px 0px rgba(0, 0, 0, .5);
  }

  .replyColor {
    width: 6px;
    min-height: @minHeight;
    max-height: @maxHeight;
  }

  .replyColumn {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 6px;
    margin-right: 6px;
  }

  .replyName {
    flex: 1;
    font-weight: 600;
    margin-right: 6px;
  }

  .replyMessageText {
    flex: 2;
  }

  .replyImageColumn {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .replyMessageImage {
    height: @maxHeight;
  }

  .typeIconContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .typeIcon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    object-fit: contain;
  }

</style>
